import {Stack, useMediaQuery, Typography} from '@mui/material';
// utils
import {PropTypes} from 'prop-types';
import {useTheme} from '@mui/material/styles';
import {numberInUSFormat} from 'mui-core/utils';
import {textloading} from 'sharedResources/assets/images';
import settingsData from 'data/settings.json';

const {showingOfResultsFor: {showingTxt, resultsTxt, ofTxt, forTxt} = {}} =
  settingsData || {};

const SearchResultsCounter = ({
  request,
  forTitle,
  totalResults,
  currentLength,
}) => {
  const theme = useTheme();
  let formattedTotalResults =
    (totalResults && numberInUSFormat(totalResults)) || 0;
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));

  const currentData = (
    <span>
      {request ? (
        <img
          alt="loader"
          height="6px"
          width="20px"
          src={textloading}
          style={{opacity: 0.5, padding: '0px 4px'}}
        />
      ) : (
        currentLength
      )}
    </span>
  );

  const totalCount = (
    <span>
      {request ? (
        <img
          alt="loader"
          height="6px"
          width="20px"
          src={textloading}
          style={{opacity: 0.5, padding: '0px 4px'}}
        />
      ) : (
        `(${formattedTotalResults})`
      )}
    </span>
  );

  if (isMobile) {
    return (
      <Stack
        direction="row"
        sx={{
          alignItems: 'center',
          justifyContent: 'flex-start',
        }}>
        <Typography
          sx={[
            theme => ({
              fontWeight: 600,
              color: theme.palette.grey.main,
              ...theme.applyStyles('dark', {
                color: theme.palette.grey.contrastText,
              }),
            }),
          ]}>
          {currentData} <em>/ </em>
          <span style={{marginLeft: 4}}>{totalCount}</span>
        </Typography>
      </Stack>
    );
  }
  return (
    <Stack
      spacing={0.5}
      direction="row"
      className="results-text"
      sx={[
        theme => ({
          fontWeight: 600,
          fontSize: '14px',
          alignItems: 'center',
          justifyContent: 'flex-start',
          color: theme.palette.grey.main,
          ...theme.applyStyles('dark', {
            color: theme.palette.grey.contrastText,
          }),
          [theme.breakpoints.down('md')]: {
            fontSize: '13px',
          },
          [theme.breakpoints.down('sm')]: {
            fontSize: '12px',
          },
        }),
      ]}>
      <span>{showingTxt}</span>
      <span>{currentData}</span>
      <span>{ofTxt}</span>
      <span>{totalCount}</span>
      <span>{resultsTxt}</span>
      {forTitle && (
        <>
          <span>{forTxt}</span>
          <span>{forTitle}</span>
        </>
      )}
    </Stack>
  );
};

SearchResultsCounter.propTypes = {
  request: PropTypes.bool,
  forTitle: PropTypes.string,
  totalResults: PropTypes.number,
  currentLength: PropTypes.number,
};
export default SearchResultsCounter;
